class GroupedGallery {
  constructor(element) {
    this.gallery = element;
    if (this.gallery.querySelector('.gallery--type-text-image')) {
      return;
    }
    this.items = element.querySelectorAll('.gallery-item');

    this._resize();
    window.addEventListener('resize', this._resize.bind(this));
  }

  _resize() {
    let rowPos = 0;
    let rowNum = -1;
    const rows = [];

    if (window.innerWidth < 480) {
      this.items.forEach(item => {
        item.querySelector('.gallery-item__group-title').style.height = null;
      });
      return;
    }

    this.items.forEach(item => {
      let currentPos = item.getBoundingClientRect().top + window.scrollY;

      // New row
      if (currentPos !== rowPos) {
        rowPos = currentPos;
        rowNum++;
        rows.push({
          row: rowNum,
          maxHeadline: item.querySelector('.gallery-item__group-title')?.offsetHeight,
          items: [item]
        })
      } else {
        rows[rowNum].items.push(item);
        rows[rowNum].maxHeadline = Math.max(rows[rowNum].maxHeadline, item.querySelector('.gallery-item__group-title')?.offsetHeight);
      }
    });

    rows.forEach(row => {
      row.items.forEach(item => {
        item.querySelector('.gallery-item__group-title').style.height = `${row.maxHeadline}px`;
      });
    });
  }
}

export default GroupedGallery;
